"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importStar(require("react"));
var RadioGroupContext_1 = __importDefault(require("./RadioGroupContext"));
var defaultProps_1 = __importDefault(require("./defaultProps"));
var RadioGroup = function (_a) {
    var children = _a.children, defaultSelectedId = _a.defaultSelectedId, onChange = _a.onChange;
    var _b = react_1.default.useState(defaultSelectedId), selectedId = _b[0], setSelectedOptionId = _b[1];
    (0, react_1.useEffect)(function () {
        setSelectedOptionId(defaultSelectedId);
    }, [defaultSelectedId]);
    var setSelectedId = function (currentId) {
        onChange(currentId, selectedId);
        setSelectedOptionId(currentId);
    };
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(RadioGroupContext_1.default.Provider, { value: { selectedId: selectedId, setSelectedId: setSelectedId }, children: children }) }));
};
RadioGroup.defaultProps = defaultProps_1.default;
exports.default = RadioGroup;
//# sourceMappingURL=RadioGroup.js.map